// SharedDeviceSignOuts — the two idle sign-outs a shared device relies on,
// mounted together and OUTSIDE every gate in the authenticated shell.
//
//   useDeviceIdleSignOut — a paired app device, per its profile window;
//   KioskIdleLogout      — a `?kiosk=1` tablet, 15 minutes.
//
// ⚠️ NEVER move this inside <LockoutGate>, <ConsentGate> or <TenantStatusGate>
// in App.tsx. Each of those renders its own screen INSTEAD OF its children when
// it fires, and anything among the children unmounts with the app. Both
// sign-outs sat inside <ConsentGate> until 6 Oct 2026, so a worker who walked
// away from the full-screen privacy/terms prompt left the tablet signed in as
// them, under the prompt, with no timer running — the next person could only
// clear it by accepting in the first worker's name. Pinned by
// SharedDeviceSignOuts.test.tsx, which reads App.tsx.
//
// Needs only the router (useNavigate): main.tsx mounts <BrowserRouter> above
// <App/>. No query client, tenant or user context.

import KioskIdleLogout from '@/components/KioskIdleLogout'
import { useDeviceIdleSignOut } from '@/hooks/useDeviceIdleSignOut'

export function SharedDeviceSignOuts() {
  useDeviceIdleSignOut()
  return <KioskIdleLogout />
}
